// extracted by extract-css-chunks-webpack-plugin
module.exports = {"videoContainer":"iXdlr","videoPlay":"bkc5u","loader":"-dvYD","placeholder":"_9HPJH","containerHeight":"_2hkYh"};